import { Component } from '@angular/core';
import { AccordionContentComponent } from '../accordion_content.component';

@Component({
  selector: 'yi-woo-activate-plugin',
  template: require('./woo_activate_plugin.component.html'),
  styles: [require('./woo_activate_plugin.component.scss')]

})

export class WooActivatePluginComponent extends AccordionContentComponent {

}
